import { useQuery } from '@tanstack/react-query'
import { fetchRdns, fetchSelf } from '../api/client'

/** The visitor's own address and geoip details. */
export function useSelf() {
    return useQuery({
        queryKey: ['self'],
        queryFn: ({ signal }) => fetchSelf(signal),
        staleTime: 5 * 60_000,
        // retry policy is the client's, so it can be overridden wholesale
    })
}

/** Reverse lookup, enabled only once the address is known. Absent PTR is normal. */
export function useRdns(ip: string | undefined) {
    return useQuery({
        queryKey: ['rdns', ip],
        queryFn: ({ signal }) => fetchRdns(ip as string, signal),
        enabled: Boolean(ip) && ip !== '0.0.0.0',
        staleTime: 5 * 60_000,
        retry: false,
    })
}
